import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Callout, Checkbox } from "../ui";
import apiClient from "../../utils/apiClient";

/**
 * The form builder's "Verify mobile number with OTP" switch.
 *
 * The code is sent through the institute's OWN SMS gateway (Settings → Email
 * & SMS), so the switch needs one. While that gateway is off or failing the
 * form still takes enquiries — just unverified — rather than turning leads
 * away (vc_be services/enquiryOtpService.js). The copy says so, because a
 * switch that is on but not doing anything must not look like it is.
 */
export default function PhoneOtpSetting({ checked, onChange, hasPhoneField }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let cancelled = false;
    apiClient.get("/enquiry-forms/phone-otp-status")
      .then(({ data }) => { if (!cancelled) setStatus(data); })
      .catch(() => { if (!cancelled) setStatus({ gatewayOn: false, healthy: false }); });
    return () => { cancelled = true; };
  }, []);

  const gatewayOn = !!status?.gatewayOn;
  const description = !hasPhoneField
    ? "Add a Phone field to this form first."
    : "Before the form is sent, visitors type a 6-digit code we text to the number they entered. Enquiries arrive marked as verified.";

  return (
    <div className="tw-flex tw-flex-col tw-gap-3">
      <Checkbox
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        // Leave an already-on switch changeable, so it can always be turned off.
        disabled={!checked && (!hasPhoneField || !gatewayOn)}
        label="Verify mobile number with OTP"
        description={description}
      />
      {status && !gatewayOn && (
        <Callout tone="info">
          <span>
            This needs your own SMS gateway.{" "}
            <Link to="/settings?tab=communications">Set it up in Settings → Email &amp; SMS</Link>.
            {checked && " Until then this form accepts enquiries without a code."}
          </span>
        </Callout>
      )}
      {checked && gatewayOn && !status.healthy && (
        <Callout tone="warning">
          Your SMS gateway is failing, so this form is accepting enquiries without a code until it works again.
        </Callout>
      )}
    </div>
  );
}
